import { connect } from 'react-redux';
import Global from '../../../../store/global-selectors';
import { BulkErrorsAndWarningsService } from '../../../../services/bulk-errors-and-warnings-service/';
import { LabelBatchErrorWarn } from './index';

const mapStateToProps = (state, ownProps) => {
  const { batchId } = ownProps;
  const batchEntity = Global.selectEntitiesBatchByFulfillmentPlanSetId(state, {
    fulfillmentPlanSetId: batchId,
  });
  const { errorsAndWarnings, totalLabels } = batchEntity;
  const groupedErrorsAndWarnings = BulkErrorsAndWarningsService.groupErrorsAndWarningsByFulfillmentPlanAndType(errorsAndWarnings);
  return {
    batchId,
    job: {
      errorsAndWarnings: groupedErrorsAndWarnings,
      included: [],
      excluded: [],
      errored: [],
      andPrint: false,
    },
    totalLabels,
  };
};

export const LabelBatchErrorOrWarnContainer = connect(mapStateToProps)(LabelBatchErrorWarn);
